import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=c150d5b8&scoped=true"
import script from "./SettingModal.vue?vue&type=script&lang=js"
export * from "./SettingModal.vue?vue&type=script&lang=js"
import style0 from "./SettingModal.vue?vue&type=style&index=0&id=c150d5b8&prod&lang=scss&scoped=true"
import style1 from "./SettingModal.vue?vue&type=style&index=1&id=c150d5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c150d5b8",
  null
  
)

export default component.exports